export default __webpack_public_path__ + "static/media/gltf.8a87d5c1.png";